import {createContext} from "react"
export const StWorkflowContext = createContext({
    stWorkflowContext: null,
    setStWorkflowAction: () => {},
})